
export default function Footer() {
  return (
    <footer className="bg-[#444c42] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Emergency Section */}
          <div className="lg:col-span-1">
            <div className="bg-gradient-to-br from-red-600 to-red-700 rounded-2xl p-6 shadow-2xl">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-alarm-warning-line text-3xl text-white"></i>
                <h3 className="text-2xl font-bold text-white">
                  Dental<br />Emergency?
                </h3>
              </div>
              <p className="text-white/95 text-sm mb-4 leading-relaxed">
                If you're experiencing a dental emergency, please call us immediately.
              </p>
              <p className="text-white/90 text-xs mb-4 leading-relaxed">
                Out-of-hours emergency services are available, subject to availability. Additional call-out fees apply.
              </p>
              <a
                href="tel:01245465586"
                className="inline-flex items-center gap-2 bg-white text-red-600 px-6 py-3 rounded-full font-bold text-base hover:bg-red-50 transition-all duration-300 whitespace-nowrap cursor-pointer w-full justify-center"
              >
                <i className="ri-phone-line text-lg"></i>
                Call Now: 01245 465586
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#features" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  Our Features
                </a>
              </li>
              <li>
                <a href="#about" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  Meet Our Team
                </a>
              </li>
              <li>
                <a href="#process" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  Our Process
                </a>
              </li>
              <li>
                <a href="#faq" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  FAQs
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h3 className="text-xl font-bold mb-6">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <a href="https://beaulieudental.co.uk" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  Sedation Dentistry
                </a>
              </li>
              <li>
                <a href="https://beaulieudental.co.uk/treatments/invisalign/" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  Invisalign Treatment
                </a>
              </li>
              <li>
                <a href="https://beaulieudental.co.uk/treatments/dental-implants/" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  Dental Implants
                </a>
              </li>
              <li>
                <a href="https://beaulieudental.co.uk/treatments/composite-dental-bonding/" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  Composite Bonding
                </a>
              </li>
              <li>
                <a href="https://beaulieudental.co.uk/our-treatments/" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  General Dentistry
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">Get in Touch</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#d0a24f] text-xl mt-1 flex-shrink-0"></i>
                <a 
                  href="https://maps.app.goo.gl/wu8HnkCBvDGsAKPz5"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer"
                >
                  11 Centenary Way, Beaulieu Square,<br />
                  Springfield, Chelmsford CM1 6AU
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-[#d0a24f] text-xl"></i>
                <a href="tel:01245465586" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  01245 465586
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-[#d0a24f] text-xl"></i>
                <a href="https://wa.me/447426343848" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  07426 343848
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-[#d0a24f] text-xl"></i>
                <a href="mailto:appointments@beaulieudental.co.uk" className="text-white/80 hover:text-[#d0a24f] transition-colors cursor-pointer">
                  appointments@beaulieudental.co.uk
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-white/70 text-sm text-center md:text-left">
              <p className="mb-2">
                © 2026 Beaulieu Dental. All rights reserved. Designed by Elevareo
              </p>
              <p className="text-xs leading-relaxed">
                Providing gentle, anxiety-friendly dental care in Chelmsford for over 6 years. Your comfort is our priority.
              </p>
            </div>
            <div className="flex items-center gap-6">
              <a href="https://beaulieudental.co.uk/policies/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[#d0a24f] transition-colors text-sm cursor-pointer">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
